import type { BillingPeriod } from './plans';


export const STRIPE_PRICE_IDS: Record<string, Record<BillingPeriod, string | null>> = {
    free          : {
        monthly: null,
        yearly : null,
    },
    starter       : {
        monthly: process.env.NEXT_PUBLIC_STRIPE_PRICE_STARTER_MONTHLY ?? null,
        yearly : process.env.NEXT_PUBLIC_STRIPE_PRICE_STARTER_YEARLY ?? null,
    },
    business      : {
        monthly: process.env.NEXT_PUBLIC_STRIPE_PRICE_BUSINESS_MONTHLY ?? null,
        yearly : process.env.NEXT_PUBLIC_STRIPE_PRICE_BUSINESS_YEARLY ?? null,
    },
    'business-pro': {
        monthly: process.env.NEXT_PUBLIC_STRIPE_PRICE_BUSINESS_PRO_MONTHLY ?? null,
        yearly : process.env.NEXT_PUBLIC_STRIPE_PRICE_BUSINESS_PRO_YEARLY ?? null,
    },
    enterprise    : {
        monthly: null,
        yearly : null,
    },
};
